///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { AppLayoutViewComponent } from "./modules/application/app-layout/app-layout.view.component";
import { AuthenticationGuardService } from "./core/auth/authentication-guard.service";

const routes: Routes = [
    {
        path: "auth-callback",
        component: AuthCallbackComponent,
    },
    {
        path: "",
        component: AppLayoutViewComponent,
        canActivate: [AuthenticationGuardService],
        children: [
            {
                path: "booking",
                loadChildren: "./modules/booking/booking.module#BookingModule",
            },
            {
                path: "historical-bookings",
                loadChildren:
                    "./modules/historical-bookings/historical-bookings.module#HistoricalBookingsModule",
            },
            {
                path: "exchange-point",
                loadChildren:
                    "./modules/exchange-point/exchange-point.module#ExchangePointModule",
            },
            {
                path: "contact",
                loadChildren: "./modules/contact/contact.module#ContactModule",
            },
            {
                path: "group-booking",
                loadChildren:
                    "./modules/group-booking/group-booking.module#GroupBookingModule",
            },
            {
                path: "service-line",
                loadChildren:
                    "./modules/service-line/service-line.module#ServiceLineModule",
            },
            {
                path: "shuttle-service",
                loadChildren:
                    "./modules/shuttle-service/shuttle-service.module#ShuttleServiceModule",
            },
            {
                path: "guided-tours",
                loadChildren:
                    "./modules/guided-tours/guided-tours.module#GuidedToursModule",
            },
            {
                path: "general",
                loadChildren: "./modules/general/general.module#GeneralModule",
            },
            {
                path: "group-service",
                loadChildren:
                    "./modules/group-service/group-service.module#GroupServiceModule",
            },
        ],
    },
    { path: "**", redirectTo: "" },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/Repositories/wfa3/SupplierPortal/app/src/app/app-routing.module.ts